import { Licenses } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectSnapshotOpen } from "plugins/PDFv2/PDFSlice"
import { selectIsDomainWhiteListed, selectUserLicense } from "user/profile/selectors"
import { sidePanelModes } from "./constants"
import { SidePanelAssetsList } from "./lists/SidePanelAssetsList"
import { SidePanelLayersList } from "./lists/SidePanelLayersList"
import { SidePanelPDFsList } from "./lists/SidePanelPDFsList"
import { SidePanelDivider } from "./SidePanelDivider"
import { SidePanelClosedHeader, SidePanelOpenHeader } from "./SidePanelHeaders"
import { SidePanelTryAddOns } from "./SidePanelTryAddOns"
import { selectActiveLayerId, selectIsSidePanelCollapsed, selectSidePanelMode } from "./slice.new"
import { useSidePanelActiveFeatureData } from "./useSidePanelActiveFeature"
import { SidePanelTabSelectAndSearchAndFilter } from "./SidePanelSearchAndFilter"

export function SidePanelContent() {
    const activeFeatureSidePanelPlugin = useSidePanelActiveFeatureData()
    const activeLayerId = useAppSelector(selectActiveLayerId)
    if (activeFeatureSidePanelPlugin) {
        return (
            <activeFeatureSidePanelPlugin.SidePanelComponent
                id={activeLayerId}
                plugin={activeFeatureSidePanelPlugin}
            />
        )
    }
    return <SidePanelListContent />
}

function SidePanelListContent() {
    const isSidePanelCollapsed = useAppSelector(selectIsSidePanelCollapsed)
    const pdfSnapshotOpen = useAppSelector(selectSnapshotOpen())
    const sidePanelMode = useAppSelector(selectSidePanelMode)
    return (
        <>
            {pdfSnapshotOpen ? (
                <div className="pt-2">
                    <SidePanelDivider />
                </div>
            ) : isSidePanelCollapsed ? (
                <SidePanelClosedHeader />
            ) : (
                <SidePanelOpenHeader />
            )}
            <SidePanelTabSelectAndSearchAndFilter />
            <SidePanelList mode={sidePanelMode} />
            <SidePanelLicenceWarning />
        </>
    )
}

function SidePanelList({ mode }: { mode: (typeof sidePanelModes)[number] }) {
    switch (mode) {
        case "Layers":
            return <SidePanelLayersList />
        case "Assets":
            return <SidePanelAssetsList />
        case "PDFs":
            return <SidePanelPDFsList />
    }
}

function SidePanelLicenceWarning() {
    const currentLicense = useAppSelector(selectUserLicense)
    const currentLicenseType = currentLicense?.subscriptionType || Licenses.Lite
    const isDomainWhitelisted = useAppSelector(selectIsDomainWhiteListed)
    if (currentLicenseType !== Licenses.Lite || isDomainWhitelisted) return null
    return <SidePanelTryAddOns />
}
